<p-table #dt
         [rowHover]="true" [value]="esocPatientsInvoiceData" dataKey="id">
  <ng-template pTemplate="header">
    <tr class="gc-table-filter">
      <th pSortableColumn="submittedOn" id="patientID">Patient ID</th>
      <th pSortableColumn="submittedBy" id="iDoc">iDoc</th>
      <th pSortableColumn="caseManager" id="deliveryStatus">Delivery Status</th>
      <th pSortableColumn="patient" id="activityDate">Activity Date</th>
      <th pSortableColumn="sentVia" id="createdBy">createdBy</th>
      <th pSortableColumn="" id="createdAt">createdAt</th>
      <th pSortableColumn="" id="updatedBy">UpdatedBy</th>
      <th pSortableColumn="" id="UpdatedAt">UpdatedAt</th>
    </tr>
  </ng-template>
  <ng-template let-esocPatientsData let-rowIndex="rowIndex" pTemplate="body">
    <tr class="p-selectable-row">
      <td>{{esocPatientsData?.patientId}}</td>
      <td>{{esocPatientsData?.iDoc}}</td>
      <td>{{esocPatientsData?.deliveryStatus}}</td>
      <td>{{esocPatientsData?.activityDate | date: dateFormat}}</td>
      <td>{{esocPatientsData?.createdBy}}</td>
      <td>{{esocPatientsData?.createdAt}}</td>
      <td>{{esocPatientsData?.UpdatedBy}}</td>
      <td>{{esocPatientsData?.UpdatedAt}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" style="text-align: center">
              <span>
                  <em class="pi pi-exclamation-circle mr-2"></em>
                    No IO Document invoice found
              </span>
      </td>
    </tr>
  </ng-template>
</p-table>
<!--<div>-->
<!--  <p-paginator #paginator (onPageChange)="paginate($event)" [rowsPerPageOptions]="rowsPerPageOptions" [rows]="noOfPatientPerRow" [totalRecords]="totalPatients" styleClass="gc-paginator"-->
<!--  ></p-paginator>-->
<!--</div>-->
